import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { saveConfigs } from '../../../redux/ConfigState/ConfigState.actions';
import { doFireStatusUpdate } from '../../../utils/CallbackUtils';
/**
 * Util to handle Progress Update command from User address
 * @param statusUpdate
 * @param dispatchAddressUpdate
 * @param dispatch
 * @param ui
 */
export var handleUAProgressUpdate = function handleUAProgressUpdate(params) {
  var statusUpdate = params.statusUpdate,
    dispatch = params.dispatch,
    ui = params.ui;
  var _ref = statusUpdate.payload.data,
    addressFetchCompleted = _ref.addressFetchCompleted;
  dispatch(saveConfigs({
    ui: _objectSpread(_objectSpread({}, ui), {}, {
      addressFetchCompleted: addressFetchCompleted
    })
  }));
  doFireStatusUpdate([statusUpdate]);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/UserAddress/utils/handleUAProgressUpdate.js
// module id = 4556
// module chunks = 11